import { generatePKCEPair } from "@/shared/utils/PKCECodeGenerator";
import * as VKID from "@vkid/sdk";
import { useEffect, useRef } from "react";

export const VK_CODE_VERIFIER_KEY = "vk_code_verifier";

const AuthVk = () => {
  const oneTapWrapperRef = useRef<HTMLDivElement>(null);
  const isInitializedRef = useRef(false);


  useEffect(() => {
    const pair = generatePKCEPair();
    const codeVerifier = pair.codeVerifier;
    try {
      localStorage.setItem(VK_CODE_VERIFIER_KEY, codeVerifier);
    } catch {
      // ignore
    }
    const redirectUrl =
      import.meta.env.VITE_VK_REDIRECT_URL || "https://localhost";

    VKID.Config.init({
      app: Number(import.meta.env.VITE_VK_APP_ID) || 54396823,
      redirectUrl,
      state: codeVerifier,
      codeVerifier,
      scope: "email phone",
      mode: VKID.ConfigAuthMode.Redirect,
    });
  }, []);

  useEffect(() => {
    if (isInitializedRef.current || !oneTapWrapperRef.current) return;

    const oneTap = new VKID.OneTap();
    oneTap
      .render({ container: oneTapWrapperRef.current })
      .on(VKID.WidgetEvents.ERROR, (e: unknown) => {
        console.error("VK OneTap error:", e);
      });
    isInitializedRef.current = true;
  }, []);

  return <div ref={oneTapWrapperRef}></div>
 
};
export default AuthVk;
